import React, { useState, useEffect } from 'react'
import { Container, Row, Card } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { useHistory } from 'react-router'
import { useLocation } from 'react-router-dom'
import moment from 'moment'
import { RecordingList } from '../../components'
import { Recording } from '../../models'

import './index.css'

const Recordings = () => {
  const sampleRecordings = []
  const [recordings, setRecordings] = useState(sampleRecordings)
  const [tablePlaceholder, setTablePlaceholder] = useState('Loading...')
  const { instanceId } = useParams()
  const history = useHistory()

  useEffect(() => {
    ;(async () => {
      try {
        let recordingData = await Recording.get(instanceId)
        recordingData = recordingData.map((recording) => {
          return {
            instanceId: recording.instanceId,
            title: recording.title,
            id: recording._id,
            link: recording.link,
            date: moment(recording.createdAt).format('LLL'),
            s3Key: recording.s3Key,
            s3Link: recording.s3Link,
            transcriptLink: recording.transcriptLink,
            chatLink: recording.chatLink,
          }
        })
        setRecordings(recordingData)
        setTablePlaceholder('')
      } catch (e) {
        setTablePlaceholder(e.message)
      }
    })()
  }, [])

  const handleRedirect = {
    onClick: (e, row) => {
      history.push(`/recording/${row.id}`, row)
    },
  }

  const location = useLocation()

  let name = 'ALL'
  if (location.state) name = location.state.name

  return (
    <Container>
      <Card className="recordings-card">
        <Row>
          <p className="recordings-header">Recordings</p>
        </Row>
        <Row>
          <p className="course-header">{name}</p>
        </Row>
        <Row>
          <RecordingList
            recordings={recordings}
            handleRedirect={handleRedirect}
            placeholder={tablePlaceholder}
          />
        </Row>
      </Card>
    </Container>
  )
}

export default Recordings
